import { useState, useEffect } from 'react';

export interface useWindowSizeReturn {
  width: number | undefined;
  height: number | undefined;
  isDesktop: boolean | undefined;
}

export function useWindowSize(userAgent?: string) {
  const [windowSize, setWindowSize] = useState<useWindowSizeReturn>({
    width: undefined,
    height: undefined,
    isDesktop: userAgent
      ? Boolean(userAgent.match(/(Macintosh|Windows PC|Linux PC)/i))
      : undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isDesktop: window.innerWidth > 991,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

export default useWindowSize;
